import router from "./router";
import store from "./store";
import i18n from "./i18n";

export const projectsModuleRouter = router;
export const projectsModuleStore = store;
export const projectsModuleI18n = i18n;
